/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CookieConsentCategories } from './CookieConsentCategories';
import {
    CookieConsentCategoriesFromJSON,
    CookieConsentCategoriesFromJSONTyped,
    CookieConsentCategoriesToJSON,
    CookieConsentCategoriesToJSONTyped,
} from './CookieConsentCategories';

/**
 * 
 * @export
 * @interface UpdateCookieConsentBody
 */
export interface UpdateCookieConsentBody {
    /**
     * 
     * @type {CookieConsentCategories}
     * @memberof UpdateCookieConsentBody
     */
    categories: CookieConsentCategories;
    /**
     * US 'Do Not Sell/Share' + GPC signal. True = opted out of sale/sharing.
     * @type {boolean}
     * @memberof UpdateCookieConsentBody
     */
    doNotSell?: boolean;
    /**
     * Live Termly policy-document version(s) at capture, read from Termly's own cache — audit only, not a hand-maintained constant. Optional (absent if unreadable).
     * @type {string}
     * @memberof UpdateCookieConsentBody
     */
    policyVersion?: string;
    /**
     * Whether the decision came from the initial banner or a later Cookie Preferences edit. Allowed values: banner, preferences.
     * @type {string}
     * @memberof UpdateCookieConsentBody
     */
    source?: string;
    /**
     * Opaque JSON of the user's Termly consent-bearing localStorage entries, captured verbatim for exact restore on another device.
     * @type {string}
     * @memberof UpdateCookieConsentBody
     */
    termlySnapshot?: string;
}

/**
 * Check if a given object implements the UpdateCookieConsentBody interface.
 */
export function instanceOfUpdateCookieConsentBody(value: object): value is UpdateCookieConsentBody {
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function UpdateCookieConsentBodyFromJSON(json: any): UpdateCookieConsentBody {
    return UpdateCookieConsentBodyFromJSONTyped(json, false);
}

export function UpdateCookieConsentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCookieConsentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'categories': CookieConsentCategoriesFromJSON(json['categories']),
        'doNotSell': json['doNotSell'] == null ? undefined : json['doNotSell'],
        'policyVersion': json['policyVersion'] == null ? undefined : json['policyVersion'],
        'source': json['source'] == null ? undefined : json['source'],
        'termlySnapshot': json['termlySnapshot'] == null ? undefined : json['termlySnapshot'],
    };
}

export function UpdateCookieConsentBodyToJSON(json: any): UpdateCookieConsentBody {
    return UpdateCookieConsentBodyToJSONTyped(json, false);
}

export function UpdateCookieConsentBodyToJSONTyped(value?: UpdateCookieConsentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categories': CookieConsentCategoriesToJSON(value['categories']),
        'doNotSell': value['doNotSell'],
        'policyVersion': value['policyVersion'],
        'source': value['source'],
        'termlySnapshot': value['termlySnapshot'],
    };
}

